module.exports = __webpack_public_path__ + "img/hr-rock-medium-03.43f220a3.png";